const css = `.user-profile-page {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.user-profile-page.user-profile-skeleton .profile-group-title-skeleton {
  margin-bottom: var(--space-3);
}
.user-profile-page.user-profile-skeleton .profile-field-group .profile-field {
  margin-bottom: var(--space-3);
}
.user-profile-page.user-profile-skeleton .external-user-signed-documents-skeleton {
  margin-top: var(--space-5);
}
.user-profile-page.user-profile-skeleton .tabview-skeleton {
  margin-top: 24px;
}
.user-profile-page.user-profile-skeleton .tabview-skeleton .p-tabview-nav {
  margin-bottom: 16px;
}
.user-profile-page.user-profile-skeleton .tabview-skeleton .tabview-nav-item-skeleton {
  margin: 16px;
}
.user-profile-page.user-profile-skeleton .tabview-skeleton .p-tabview-panels {
  padding-top: 0;
}
.user-profile-page.user-profile-skeleton .calendar-container {
  background-color: transparent;
}
.user-profile-page.user-profile-skeleton .calendar-container .calendar-toolbar-skeleton {
  margin-bottom: 8px;
  gap: 8px;
  padding-top: 0;
}
.user-profile-page.user-profile-skeleton .calendar-container .calendar-toolbar-buttons {
  display: flex;
  gap: 8px;
}
.user-profile-page .profile-header .p-card-body {
  width: 100%;
}
.user-profile-page .profile-header .profile-hero {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-4);
}
.user-profile-page .profile-header .profile-hero-text {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  flex: 1 1 240px;
  min-width: 0;
}
.user-profile-page .profile-header .profile-hero-text .profile-info-name {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-2);
}
.user-profile-page .profile-header .profile-hero-text .profile-info-name h2 {
  margin: 0;
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-tight);
}
.user-profile-page .profile-header .profile-info-age-gender {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  color: var(--text-muted);
  font-size: var(--font-size-sm);
}
.user-profile-page .profile-header .profile-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-2);
}
.user-profile-page .profile-header .profile-sections {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: var(--space-5) var(--space-6);
  margin-top: var(--space-5);
  padding-top: var(--space-5);
  border-top: 1px solid var(--border);
}
.user-profile-page .profile-header .profile-field-group h3 {
  margin: 0 0 var(--space-3);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--text);
}
.user-profile-page .profile-header .profile-fields {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  margin: 0;
}
.user-profile-page .profile-header .profile-field {
  display: flex;
  flex-direction: column;
  gap: var(--space-0-5);
  min-width: 0;
}
.user-profile-page .profile-header .profile-field dt {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  color: var(--text-muted);
}
.user-profile-page .profile-header .profile-field dd {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-2);
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--text);
  overflow-wrap: anywhere;
}
.user-profile-page .profile-header .profile-field .success {
  color: var(--success);
}
.user-profile-page .profile-header .profile-field .error {
  color: var(--danger);
}
.user-profile-page .profile-header .profile-info-coupons dd {
  flex-direction: column;
  align-items: flex-start;
}
.user-profile-page .profile-header .profile-field-empty {
  color: var(--text-muted);
}
.user-profile-page .profile-header .supervisor-info {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}
.user-profile-page .profile-header .external-user-signed-documents {
  margin-top: var(--space-5);
}
.user-profile-page .profile-header .user-profile-extra {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--space-5);
  margin-top: var(--space-5);
  padding-top: var(--space-5);
  border-top: 1px solid var(--border);
  white-space: pre-line;
}
.user-profile-page .profile-header .user-profile-extra .diagnostic-field .diagnostic-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.user-profile-page .profile-header .user-profile-extra .diagnostic-field .diagnostic-header strong {
  margin: 0;
}
.user-profile-page .profile-header .user-profile-extra .diagnostic-field p {
  margin: 0;
  color: var(--text-muted);
  white-space: pre-line;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.user-profile-page .profile-header .user-profile-extra .diagnostic-field p .see-more-button {
  padding: 0;
  margin-left: 4px;
  vertical-align: baseline;
  font-size: inherit;
  color: var(--primary-color);
}
.user-profile-page .profile-header .user-profile-extra .objective-field .objective-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.user-profile-page .profile-header .user-profile-extra .objective-field .objective-header strong {
  margin: 0;
}
.user-profile-page .profile-header .user-profile-extra .objective-field p {
  margin: 0;
  color: var(--text-muted);
  white-space: pre-line;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.user-profile-page .profile-header .user-profile-extra .objective-field p .see-more-button {
  padding: 0;
  margin-left: 4px;
  vertical-align: baseline;
  font-size: inherit;
  color: var(--primary-color);
}
.user-profile-page .profile-header .user-profile-extra strong {
  display: block;
  margin-bottom: 8px;
}
@media (max-width: 767px) {
  .user-profile-page .profile-header .profile-hero {
    position: relative;
  }
  .user-profile-page .profile-header .profile-hero .profile-hero-text {
    padding-right: var(--space-7);
  }
  .user-profile-page .profile-header .profile-actions {
    width: 100%;
  }
  .user-profile-page .profile-header .profile-actions > .p-button:not(.p-button-icon-only) {
    flex: 1 1 40%;
  }
  .user-profile-page .profile-header .profile-actions > .p-button:not(.p-button-icon-only) .p-button-label {
    flex: 0 0 auto;
  }
  .user-profile-page .profile-header .profile-actions > .p-button:first-child:not(.p-button-outlined) {
    flex-basis: 100%;
  }
  .user-profile-page .profile-header .profile-actions > .p-button-icon-only {
    position: absolute;
    top: 0;
    right: 0;
    width: 44px;
    min-width: 0;
    height: 44px;
  }
}
.user-profile-page .reservations-calendar-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 12px 0 4px;
}
.user-profile-page .reservations-calendar-legend .legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.user-profile-page .reservations-calendar-legend .legend-item .legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}
.user-profile-page .reservations-calendar-legend .legend-item .legend-name {
  font-size: var(--font-size-xs);
  color: var(--text-color-secondary);
  font-weight: var(--font-weight-medium);
}
.user-profile-page .calendar-container {
  height: 660px;
  background-color: var(--surface-ground);
  border-radius: var(--border-radius);
}
.user-profile-page .calendar-container .rbc-calendar {
  background-color: var(--surface-card);
  border-radius: var(--border-radius);
  overflow: hidden;
  height: 100%;
}
.user-profile-page .calendar-container .rbc-calendar .rbc-month-view {
  flex: 1;
  min-height: 500px;
}
.user-profile-page .calendar-container .rbc-calendar .rbc-show-more:hover {
  background-color: transparent;
  color: var(--accent);
}
@media screen and (max-width: 576px) {
  .user-profile-page .calendar-container .rbc-calendar {
    /*       .rbc-month-view {
      min-height: 400px;
    }

    .rbc-header {
      padding: 4px;
      font-size: var(--font-size-xs);
      font-weight: var(--font-weight-semibold);
    }

    .rbc-date-cell {
      padding: 2px;
      font-size: var(--font-size-xs);
      font-weight: var(--font-weight-medium);
    }

    .rbc-event {
      padding: 2px 2px;
      min-height: 20px;
      margin: 2px;
    }

    .rbc-row-segment {
      padding: 2px;
      min-height: 20px;

      .rbc-event-content {
        font-size: var(--font-size-xs);
      }
    } */
    /* .rbc-show-more {
      font-size: var(--font-size-xs);
      padding: 2px 4px;
      background-color: var(--surface-100);
      color: var(--accent);
      border-radius: 4px;
      margin: 2px;
      white-space: nowrap;
    } */
    /* 
    .rbc-row-content {
      .rbc-row {
        &:not(:first-child) {
          max-height: 24px;
          overflow: hidden;
        }
      }
    } */
  }
}
.user-profile-page .calendar-container .user-reservations-calendar .rbc-event-content {
  container-name: user-reservation-event;
  container-type: inline-size;
}
.user-profile-page .profile-avatar-skeleton {
  width: 64px !important;
  height: 64px !important;
}
.user-profile-page .p-skeleton {
  background-color: var(--surface-ground);
}
.user-profile-page .p-skeleton::after {
  background: linear-gradient(90deg, transparent, var(--shimmer), transparent);
}

.diagnostic-dialog.p-dialog {
  width: 90vw;
  max-width: 1200px;
  gap: 0;
}
.diagnostic-dialog.p-dialog .p-dialog-content {
  min-height: 200px;
}
.diagnostic-dialog.p-dialog .diagnostic-text {
  padding: 8px 12px;
  border: 1px solid transparent;
  white-space: pre-line;
  margin: 0;
  min-height: 200px;
  color: var(--text-muted);
  font-weight: var(--font-weight-regular);
}
.diagnostic-dialog.p-dialog .p-inputtextarea {
  width: 100%;
  min-height: 200px;
  margin-bottom: 0;
}
@media screen and (max-width: 576px) {
  .diagnostic-dialog.p-dialog {
    margin: 8px;
  }
  .diagnostic-dialog.p-dialog .p-dialog-header {
    padding: 16px;
  }
  .diagnostic-dialog.p-dialog .p-dialog-content {
    padding: 0 16px 16px 16px;
  }
}

.objective-dialog.p-dialog {
  width: 90vw;
  max-width: 1200px;
  gap: 0;
}
.objective-dialog.p-dialog .p-dialog-content {
  min-height: 200px;
}
.objective-dialog.p-dialog .objective-text {
  padding: 8px 12px;
  border: 1px solid transparent;
  white-space: pre-line;
  margin: 0;
  min-height: 200px;
  color: var(--text-muted);
  font-weight: var(--font-weight-regular);
}
.objective-dialog.p-dialog .p-inputtextarea {
  width: 100%;
  min-height: 200px;
  margin-bottom: 0;
}
@media screen and (max-width: 576px) {
  .objective-dialog.p-dialog {
    margin: 8px;
  }
  .objective-dialog.p-dialog .p-dialog-header {
    padding: 16px;
  }
  .objective-dialog.p-dialog .p-dialog-content {
    padding: 0 16px 16px 16px;
  }
}

.programs {
  margin-top: 32px;
}

.program-card {
  width: 100%;
  margin-bottom: 16px;
}

.timeline-item {
  align-items: start;
}

.custom-timeline .p-timeline-event-marker {
  background-color: var(--text-muted);
  color: var(--surface-raised);
}

.custom-timeline .p-timeline-event-opposite {
  font-size: var(--font-size-sm);
  color: var(--text-muted);
  flex: 0;
  padding: 0 16px;
}

.p-tabview .p-tabview-nav {
  margin-bottom: 24px;
  gap: 16px;
}
.p-tabview .p-tabview-nav li .p-tabview-nav-link {
  padding: 16px 24px;
}
@media screen and (max-width: 576px) {
  .p-tabview .p-tabview-nav {
    flex-wrap: wrap;
    margin-bottom: 16px;
    gap: 8px;
  }
  .p-tabview .p-tabview-nav li {
    flex: 1;
    min-width: fit-content;
  }
  .p-tabview .p-tabview-nav li .p-tabview-nav-link {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 16px;
    font-size: var(--font-size-sm);
  }
}
.p-tabview .p-tabview-panels {
  padding: 16px 0;
}
@media screen and (max-width: 576px) {
  .p-tabview .p-tabview-panels {
    padding: 8px 0;
  }
}

@media screen and (max-width: 576px) {
  .calendar-container {
    height: 700px !important;
  }
  .user-profile-page .profile-header .user-profile .profile-info {
    width: 100%;
    min-width: 0;
  }
  .user-profile-page .profile-header .user-profile .profile-info .profile-info-top {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  .user-profile-page .profile-header .user-profile .profile-info .profile-info-top .profile-info-top-container {
    align-items: center;
  }
  .profile-actions {
    justify-content: center;
  }
  .profile-actions .p-button {
    min-width: 100px;
    font-size: var(--font-size-sm);
    padding: 8px 12px;
  }
}
.p-tabview .p-tabview-nav {
  border: unset;
}

.activity-tabs {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
}
.activity-tabs .tabs-header {
  display: flex;
  gap: 2px;
  background-color: var(--surface-ground);
  padding: 2px;
  border-radius: var(--border-radius);
}
.activity-tabs .tabs-header .tab-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 24px;
  background: none;
  border: none;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: all 0.2s;
  color: var(--text-color-secondary);
  font-weight: var(--font-weight-medium);
  min-width: 120px;
}
.activity-tabs .tabs-header .tab-item i {
  font-size: var(--font-size-base);
}
.activity-tabs .tabs-header .tab-item:hover:not(.active) {
  background-color: var(--surface-hover);
}
.activity-tabs .tabs-header .tab-item.active {
  background-color: var(--surface-card);
  color: var(--text);
  border: 1px solid var(--border);
  box-shadow: none;
}
@media screen and (max-width: 576px) {
  .activity-tabs {
    gap: 12px;
    margin-bottom: 12px;
  }
  .activity-tabs .tabs-header {
    padding: 2px;
  }
  .activity-tabs .tabs-header .tab-item {
    padding: 12px 12px;
    min-width: unset;
    font-size: var(--font-size-sm);
  }
  .activity-tabs .tabs-header .tab-item i {
    font-size: var(--font-size-sm);
  }
  .activity-tabs .tabs-header .tab-item span {
    display: none;
  }
  .activity-tabs .tabs-header .tab-item.active i {
    color: var(--text);
  }
}

@media screen and (max-width: 480px) {
  .user-profile-page .user-profile-activity-card {
    padding: 16px 0 0;
  }
  .user-profile-page .user-profile-activity-card .p-card-title {
    padding-left: 16px;
  }
  .user-profile-page .user-profile-activity-card .p-tabview-panels {
    padding-bottom: 0;
  }
  .user-profile-page .profile-header .user-profile .profile-info .profile-info-coupons .coupon-display, .user-profile-page .profile-header .user-profile .profile-info .profile-info-coupons > small {
    margin-left: 0;
  }
}
@container user-reservation-event (max-width: 130px) {
  .calendar-event-inside {
    flex-direction: column !important;
    gap: 2px !important;
    padding: 2px !important;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
